import { useRouter } from 'next/router';

import useTranslation from 'hooks/use-translation';
import { useMarketplaceDispensaryGenericCategoryRoutes } from 'shop/hooks/categories/use-marketplace-dispensary-generic-category-routes';

import { getGenericCategoryRouteInfo } from 'src/shop/utils/categories';
import { getPathToShopDispensaryCategory } from 'utils/helpers/route';

import { CategoryLink, UseCategoryLinksReturn } from './use-category-links.types';

export function useMarketplaceDispensaryCategoryLinks(): UseCategoryLinksReturn {
  const { t } = useTranslation();
  const {
    asPath,
    query: { cName },
    isReady,
  } = useRouter();

  const { categories, loading } = useMarketplaceDispensaryGenericCategoryRoutes();

  if (typeof cName !== 'string') {
    return { categoryLinks: [], loading: !isReady };
  }

  const categoryLinks = categories.map(
    (category): CategoryLink => {
      const {
        translation: [transKey, transDefault],
        imgSrc,
      } = getGenericCategoryRouteInfo(category);

      const label = t(transKey, transDefault);
      const href = getPathToShopDispensaryCategory(cName, category);
      const isActive = asPath.includes(href);

      return { label, href, isActive, imgSrc };
    }
  );

  return {
    categoryLinks,
    loading,
  };
}
